import { IThreeDImageDetail } from '@types';
import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useQuery } from '@tanstack/react-query';

//3D 이미지 상세 모달에 보여줄 정보 불러오기
async function getThreeDImageDetail(
  assetThreeDId: number | null
): Promise<AxiosResponse<FetchResult<IThreeDImageDetail>>> {
  const response = await instance.get(`/assets-3d/${assetThreeDId}`);
  return response;
}

const useFetchThreeDImageDetail = (assetThreeDId: number | null) => {
  const { data: originalData, isLoading } = useQuery({
    queryKey: ['get', `/assets-3d/${assetThreeDId}`],
    queryFn: () => getThreeDImageDetail(assetThreeDId),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(assetThreeDId)
  });

  const data = originalData?.data.data;

  return { data, isLoading };
};

export default useFetchThreeDImageDetail;
